import * as React from 'react';
import * as s from './Hero.scss';
import experiments from '../../utils/experiments';
import {InjectedTranslateProps, translate} from 'react-i18next';
import LinkMore from '../LinkMore';
import {reportClick} from '../../utils/bi';
import Text from '../Text';

export interface HeroConfig {
  staticsBaseUrl: string;
  imgFolder: string;
  key: string;
}

interface HeroProps extends InjectedTranslateProps, HeroConfig {
}

const Hero: React.SFC<HeroProps> = ({staticsBaseUrl, imgFolder, t}) => {
  const isNewTitle = String(experiments.get('specs.marketing.HomepageNewTitle')) === 'true';
  return (
    <div
        className={`page-fold ${s.hero}`}
        data-hook="hero-fold"
        data-foldname="hero"
        data-foldnum="1"
    >
      <div className={s.heroWrap}>
        <picture>
          <source media="(min-width: 1440px)" srcSet={`${staticsBaseUrl}${imgFolder}/homepage-hero-xlarge.jpg`}/>
          <source media="(min-width: 1024px)" srcSet={`${staticsBaseUrl}${imgFolder}/homepage-hero-large.jpg`}/>
          <source media="(min-width: 560px)"  srcSet={`${staticsBaseUrl}${imgFolder}/homepage-hero-mobile-landscape-v2.jpg`}/>
          <source srcSet={`${staticsBaseUrl}${imgFolder}/homepage-hero-mobile-v2.jpg`}/>
          <img src={`${staticsBaseUrl}${imgFolder}/homepage-hero-xlarge.jpg`} alt={t('seo_hero_alt')}/>
        </picture>
        <div className={s.heroContent}>
          <div>
            <Text parent="h1" i18nKey={isNewTitle ? 'hero.title.new' : 'hero.title'} />
            <Text parent="h2" i18nKey="hero.subtitle" />
            <LinkMore
              className={s.linkMore}
              theme="button"
              data-hook="hero-get-started"
              data-foldname="hero"
              onClick={reportClick}
            >
              {t('hero.getStarted')}
            </LinkMore>
          </div>
        </div>
      </div>
    </div>
  );
};

export default translate()(Hero);
